import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../utils/error";
import { useRequest } from "../../utils/request";
import { accountLatestUnderwritingQueryKey } from "./account.keys";

export const useFetchLatestSuretyAccountUnderwriting = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: accountLatestUnderwritingQueryKey(accountId),
		queryFn: async () => {
			try {
				return await get<Dtos.SuretyAccount.Underwriting.Get.Response>(
					`/v2/surety/accounts/${accountId}/underwritings/latest`,
				);
			} catch (error) {
				if (error instanceof ApiError && error.statusCode === 404) {
					return null;
				}

				throw error;
			}
		},
	});

	return {
		latestUnderwriting: data,
		latestUnderwritingError: error,
		latestUnderwritingIsLoading: isLoading,
	};
};
